module.exports = __webpack_public_path__ + "static/fonts/iconfont.85960312.woff2";